import React from "react";
import "./ReusableButton.css";

interface ReusableButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "outlined";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
}

const ReusableButton: React.FC<ReusableButtonProps> = ({
  label,
  onClick,
  type = "button",
  variant = "primary",
  startIcon,
  endIcon,
  disabled = false,
  loading = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`reusable-button ${variant}`}
      disabled={disabled || loading}
    >
      {loading ? (
        <span className="button-loader">
          <span></span>
          <span></span>
          <span></span>
        </span>
      ) : (
        <>
          {startIcon && (
            <span className="button-icon start-icon">{startIcon}</span>
          )}
          <span className="button-label">{label}</span>
          {endIcon && <span className="button-icon end-icon">{endIcon}</span>}
        </>
      )}
    </button>
  );
};

export default ReusableButton;
